/* eslint-disable no-alert */
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';

const useFileHandler = (initState) => {
  const [imageFile, setImageFile] = useState(initState);
  const [isFileLoading, setFileLoading] = useState(false);

  const removeImage = ({ id, name }) => {
    const items = imageFile[name].filter((item) => item.id !== id);

    setImageFile({
      ...imageFile,
      [name]: items
    });
  };

  const onFileChange = async (event, { name, type }) => {

    const val = event.target.value;
    const img = event.target.files[0];
    const regex = /(\.jpg|\.jpeg|\.png)$/i;


      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 2160,
        useWebWorker: true
      }
        const compressedFile = await imageCompression(img, options);
        //console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
       // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB




       const size = compressedFile.size / 1024 / 1024;






    setFileLoading(true);
    if (!regex.exec(val)) {
      alert('File type must be JPEG or PNG', 'error');
      setFileLoading(false);
    } else if (size > 0.9) {
      alert('File size exceeded 9MB, consider optimizing your image', 'error');
      setFileLoading(false);
    } else if (type === 'multiple') {
      Array.from(event.target.files).forEach(async (file) => {

        const CFile = await imageCompression(file, options);

        const reader = new FileReader();
        reader.addEventListener('load', (e) => {
          setImageFile((oldFiles) => ({
            ...oldFiles,
            [name]: [...oldFiles[name], {file: CFile, url: e.target.result, id: uuidv4() }]
          }));
        });
        reader.readAsDataURL(CFile);
      });

      setFileLoading(false);
    } else { // type is single
      const reader = new FileReader();

      reader.addEventListener('load', (e) => {
        setImageFile({
          ...imageFile,
          [name]: { file: compressedFile, url: e.target.result }
        });
        setFileLoading(false);
      });
      reader.readAsDataURL(compressedFile);
    }
  };

  return {
    imageFile,
    setImageFile,
    isFileLoading,
    onFileChange,
    removeImage
  };
};

export default useFileHandler;
